module.exports = __webpack_public_path__ + "static/media/clock_icon.da9dfb46.svg";